import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.modal.major_shareholder_check_form.title',
        defaultMessage: 'Add a person'
    },
    nameFieldLabel: {
        id: '_.modal.major_shareholder_check_form.name_field_label',
        defaultMessage: 'Full name'
    },
    titleFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.title_field_placeholder',
        defaultMessage: 'Title'
    },
    firstNameFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.first_name_field_placeholder',
        defaultMessage: 'First name'
    },
    lastNameFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.last_name_field_placeholder',
        defaultMessage: 'Last name'
    },
    dayFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.day_field_placeholder',
        defaultMessage: 'Day (e.g. 05)'
    },
    monthFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.month_field_placeholder',
        defaultMessage: 'Month'
    },
    yearFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.year_field_placeholder',
        defaultMessage: 'Year (e.g. 1995)'
    },
    addressFieldsTitle: {
        id: '_.modal.major_shareholder_check_form.address_fields_title',
        defaultMessage: 'Address details:'
    },
    postcodeFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.postcode_field_placeholder',
        defaultMessage: 'Enter a postcode'
    },
    emptyPostcodeError: {
        id: '_.modal.major_shareholder_check_form.empty_postcode_error',
        defaultMessage: 'Enter a postcode'
    },
    noMatchingPostcodesError: {
        id: '_.modal.major_shareholder_check_form.no_matching_postcodes_error',
        defaultMessage: 'There are no matching postcodes'
    },
    toggleManualAddressCTA: {
        id: '_.modal.major_shareholder_check_form.toggle_manual_address_cta',
        defaultMessage: 'Enter address manually'
    },
    toggleEnterPostcodeCTA: {
        id: '_.modal.major_shareholder_check_form.toggle_enter_postcode_cta',
        defaultMessage: 'Search for my address'
    },
    houseNumberFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.house_number_field_placeholder',
        defaultMessage: 'House number'
    },
    houseNumberFieldLabel: {
        id: '_.modal.major_shareholder_check_form.house_number_field',
        defaultMessage: 'House number'
    },
    houseNameFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.house_name_field_placeholder',
        defaultMessage: 'House name'
    },
    houseNameFieldLabel: {
        id: '_.modal.major_shareholder_check_form.house_name_field',
        defaultMessage: 'House name'
    },
    streetLineOneFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.street_line_one_field_placeholder',
        defaultMessage: 'Street line 1'
    },
    streetLineOneFieldLabel: {
        id: '_.modal.major_shareholder_check_form.street_line_one_field',
        defaultMessage: 'Street line 1'
    },
    streetLineTwoFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.street_line_two_field_placeholder',
        defaultMessage: 'Street line 2'
    },
    streetLineTwoFieldLabel: {
        id: '_.modal.major_shareholder_check_form.street_line_two_field',
        defaultMessage: 'Street line 2'
    },
    townFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.town_field_placeholder',
        defaultMessage: 'Town'
    },
    townFieldLabel: {
        id: '_.modal.major_shareholder_check_form.town_field',
        defaultMessage: 'Town'
    },
    postcodeManualFieldPlaceholder: {
        id: '_.modal.major_shareholder_check_form.postcode_manual_field_placeholder',
        defaultMessage: 'Postcode'
    },
    postcodeManualFieldLabel: {
        id: '_.modal.major_shareholder_check_form.postcode_manual_field',
        defaultMessage: 'Postcode'
    },
    guarantorHint: {
        id: '_.modal.major_shareholder_check_form.guarantor_hint',
        defaultMessage: 'Contact your account manager to add a guarantor'
    },
    validNameRequired: {
        id: '_.modal.major_shareholder_check_form.error.valid_name_required',
        defaultMessage: 'Please enter a valid name'
    },
    validDOBRequired: {
        id: '_.modal.major_shareholder_check_form.error.valid_DOB_required',
        defaultMessage: 'Please enter a valid date of birth'
    },
    validAddressRequired: {
        id: '_.modal.major_shareholder_check_form.error.valid_address_required',
        defaultMessage: 'Please enter an address'
    },
    validTownRequired: {
        id: '_.modal.major_shareholder_check_form.error.valid_town_required',
        defaultMessage: 'Town required'
    },
    validPostcodeRequired: {
        id: '_.modal.major_shareholder_check_form.error.valid_postcode_required',
        defaultMessage: 'Postcode required'
    },
    cancelCTA: {
        id: '_.modal.major_shareholder_check.cancel_cta',
        defaultMessage: 'Cancel'
    },
    saveCTA: {
        id: '_.modal.major_shareholder_check.next_cta',
        defaultMessage: 'Save'
    }
});
